import icons from 'url:../../img/icons.svg';
import view from './view.js';

class paginationView extends view {
  _parentEl = document.querySelector(`.pagination`);

  _generatePrevBtn(currPage) {
    return `<button class="btn--inline pagination__btn--prev" data-goto = ${
      currPage - 1
    }>
      <svg class="search__icon">
      <use href="${icons}#icon-arrow-left"></use>
      </svg>
      <span>Page ${currPage - 1}</span>
      </button>`;
  }

  _generateNextBtn(currPage) {
    return `<button class="btn--inline pagination__btn--next" data-goto = ${
      currPage + 1
    }>
    <span>Page ${currPage + 1}</span>
    <svg class="search__icon">
    <use href="${icons}#icon-arrow-right"></use>
    </svg>
    </button>`;
  }

  _generateMarkup() {
    const numPage = Math.ceil(this._data.result.length / this._data.resPerPage);
    const currPage = this._data.page;

    // Case 1 : page 1 and there are other pages
    if (currPage === 1 && numPage > 1) return this._generateNextBtn(currPage);

    // Case 2 : Last page
    if (currPage === numPage && numPage > 1)
      return this._generatePrevBtn(currPage);

    // Case 3 : Other page
    if (currPage < numPage)
      return `${this._generatePrevBtn(currPage)}${this._generateNextBtn(
        currPage
      )}`;

    // case 4 : page 1 and no other page
    return '';
  }

  addHandlerClick(subscriber) {
    this._parentEl.addEventListener(`click`, function (e) {
      const btn = e.target.closest(`.btn--inline`);
      if (!btn) return;
      const goToPage = +btn.dataset.goto;
      subscriber(goToPage);
    });
  }
}

export default new paginationView();
